export default {
  data() {
    return {
      videoCurrentTime: 0,
      videoElement: document.createElement('video'),
      show: false,
      playing: false,
      duration: 0,
    };
  },
  props: {
    playsinline: {
      type: Boolean,
      default: true,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    controls: {
      type: Boolean,
      default: false,
    },
    videoRef: {
      type: String,
      default: 'video',
    },
    videoId: {
      type: String,
      required: true,
    },
    startCurrentTime: {
      type: [Number, String],
      default: 0,
    },
    setTime: {
      type: [Number, String],
      default: 2000,
    },
    playButton: {
      type: Boolean,
      default: false,
    },
    pauseButton: {
      type: Boolean,
      default: false,
    },
    startStopButton: {
      type: Boolean,
      default: false,
    },
    startStopBtnVariant: {
      type: String,
      required: false,
    },
    startStopVariantHover: {
      type: String,
      required: false,
    },
    playBtnVariant: {
      type: String,
      required: false,
    },
    playBtnVariantHover: {
      type: String,
      required: false,
    },
    playBtnOutlineColor: {
      type: String,
      required: false,
    },
    pauseBtnVariant: {
      type: String,
      required: false,
    },
    pauseBtnVariantHover: {
      type: String,
      required: false,
    },
    pauseBtnOutlineColor: {
      type: String,
      required: false,
    },
    ariaLabelPlay: {
      type: String,
      default: null,
    },
    ariaLabelPause: {
      type: String,
      default: null,
    },
    loop: {
      type: Boolean,
      default: false,
    },
  },
  provide() {
    return {
      $vp: this,
    };
  },
  mounted: function () {
    this.videoElement = this.$refs[this.videoRef];

    if (!this.videoElement) {
      throw new Error("Can't find video element ref: " + this.videoRef);
    }

    this.videoElement.ontimeupdate = () => {
      if (this.videoElement) {
        this.videoCurrentTime = this.videoElement.currentTime;
        this.$emit('onTimeupdateVideo', {
          element: this.videoElement,
          currentTime: this.videoCurrentTime,
        });
      }
    };

    this.videoElement.onloadedmetadata = () => {
      if (this.startCurrentTime) {
        this.videoElement.currentTime = this.startCurrentTime;
      }
    };

    this.videoElement.onplay = () => {
      this.playing = true;
    };
    this.videoElement.onpause = () => {
      this.playing = false;
    };

    this.videoElement.onended = () => {
      this.playing = false;
      this.$emit('onEndedVideo', this.videoElement);
    };

    this.videoElement.onloadedmetadata = () => {
      this.duration = this.videoElement.duration;
    };

    const willAutoplay = this.videoElement.autoplay;
    this.videoElement.autoplay = false;

    if (willAutoplay) {
      // setTimeout(() => {
      this.playVideo();
      this.videoElement.addEventListener('playing', this.restoreAutoplay);
      // }, 300)
    }
  },
  methods: {
    startStopVideo() {
      if (!this.playing) {
        this.playVideo();
      } else {
        this.pauseVideo();
      }
    },
    playVideo() {
      if (this.videoElement) {
        this.videoElement
          .play()
          .then(() => {
            this.$emit('onStartVideo', this.videoElement);
          })
          .catch(() => {
            this.$emit('onErrorVideo', this.videoElement);
          });
      }
    },
    pauseVideo() {
      if (this.videoElement) {
        this.videoElement.pause();
      }
    },
    restoreAutoplay() {
      this.show = true;
      this.videoElement.autoplay = true;
      this.videoElement.removeEventListener('playing', this.restoreAutoplay);
    },
    restartVideo() {
      this.videoElement.currentTime = 0;
      this.playVideo();
    },
    startVideo() {
      this.playVideo();
    },
    stopVideo() {
      this.pauseVideo();
      this.videoElement.currentTime = 0;
    },
  },
  computed: {
    currentTime() {
      return this.videoCurrentTime;
    },
  },
  destroyed() {
    this.videoCurrentTime = 0;
    this.videoElement = null;
    window.removeEventListener('focus', this.playVideo);
    window.removeEventListener('blur', this.pauseVideo);
    this.$off('onTimeupdateVideo');
    this.$off('onEndedVideo');
  },
};
